export const HOST_AVAILABILITY = {
  EVENTS: 'hostAvailabilityEvents',
  CALLS: 'hostAvailabilityCalls'
}

export const SAVE_ACTION = {
  SAVE_AS: 'save_as',
  SAVE: 'save'
}